import script from "./stripe.vue?vue&type=script&setup=true&lang=js"
export * from "./stripe.vue?vue&type=script&setup=true&lang=js"

import "./stripe.vue?vue&type=style&index=0&id=3b412001&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/v8-production-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b412001"]])

export default __exports__